import React from 'react';
import { useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import MainTemplate from 'pages/templates/MainTemplate';
import MbTabs from 'components/organisms/MbTabs';

import Statistics from './Statistics';
import Targeting from './Targeting';
import Article from './Article';
import NoPar from './NoPar';
import Unpaid from './Unpaid';
import AllParStatistics from './AllParStatistics';
import CampaignStatistics from './CampaignStatistics';
import RoasStatistics from './RoasStatistics';
import CategoryStatistics from './CategoryStatistics';
import TopMediaStatistics from './TopMediaStatistics';
import Month6Statistics from './Month6Statistics';
import FluctuationStatistics from '../AdvertiserStatistics/FluctuationStatistics';
import BrowserStatistics from './BrowserStatistics';
import CwAnalysis from './CwAnalysis';
import AppTracker from './AppTracker';
import Adblock from './Adblock';

const DailyStatistics = () => {
  let { path } = useRouteMatch();
  const { menu } = useSelector(({ menu }) => ({
    menu: menu.list === null ? new Map() : menu.list,
  }));

  const tabList = () => {
    for (let curMenu of menu.values()) {
      if (typeof curMenu.subMenu !== 'undefined') {
        const cur = curMenu.subMenu.get(path);
        if (typeof cur !== 'undefined') {
          // 현재 2dapth url에 매칭되는 것이 있으면 그 메뉴의 하위 tab 반환
          return cur.subMenu;
        }
      }
    }
  };

  return (
    <MainTemplate>
      <MbTabs
        name="AdvertiserStatistics"
        tabMenuList={tabList()}
        tabs={{
          '/report/daily/par': {
            tabComponent: <Statistics />,
          },
          '/report/daily/targeting': {
            tabComponent: <Targeting />,
          },
          '/report/daily/article': {
            tabComponent: <Article />,
          },
          '/report/daily/total': {
            tabComponent: <AllParStatistics />,
          },
          '/report/daily/noPar': {
            tabComponent: <NoPar />,
          },
          '/report/daily/roas': {
            tabComponent: <RoasStatistics />,
          },
          '/report/daily/category': {
            tabComponent: <CategoryStatistics />,
          },
          '/report/daily/campaign': {
            tabComponent: <CampaignStatistics />,
          },
          '/report/adver/fluctuation': {
            tabComponent: <FluctuationStatistics />,
          },
          '/report/daily/unpaid': {
            tabComponent: <Unpaid />,
            isPop: 1,
          },
          '/report/daily/topMedia': {
            tabComponent: <TopMediaStatistics />,
            isPop: 1,
          },
          '/report/daily/longTime': {
            tabComponent: <Month6Statistics />,
            isPop: 1,
          },
          '/report/daily/browser': {
            tabComponent: <BrowserStatistics />,
          },
          '/report/daily/cwAnalysis': {
            tabComponent: <CwAnalysis />,
          },
          '/report/daily/tracker': {
            tabComponent: <AppTracker />,
          },
          '/report/daily/adblock': {
            tabComponent: <Adblock />,
          },
        }}
      />
    </MainTemplate>
  );
};

export default DailyStatistics;
